import { Colors, Spacing } from "_styles";
// import { JobCardWidth, JobCardHeight, TimelineColumnWidthRaw } from "_utils";
import { JobCardWidth } from "../timeline-constants";

export const mainContainer = {
    width: JobCardWidth,
    textAlign: "left",
    borderStyle: "solid",
    borderColor: Colors.GRAY_DARK,
    borderWidth: "1.5px",
    borderRadius: "5px",
    //borderTopWidth: 3,
};

export const gateParagraph = {
    margin: "0px 0",
    color: Colors.PRM_LIGHT_BLUE,
    textAlign: "left",
    fontSize: '10px',
};
export const flightNumberParagraph = {
    margin: 0, textAlign: 'center', fontSize: '12px', fontWeight: 'bold'
}
export const SeatNumberParagraph = {
    margin: "0px 0", textAlign: "center", fontSize: 8, color: Colors.PRM_LIGHT_BLUE, fontWeight: "bold"
}
export const assistanceParagraph = {
    margin: "0px 0",
    color: Colors.PRM_LIGHT_BLUE,
    textAlign: "left",
    fontSize: 8,
}
export const statusCircle = {
    width: Spacing.SCALE_6,
    height: Spacing.SCALE_6,
    borderRadius: 50,
}

export const delayTimerDiv = {
    position: "absolute",
    bottom: 4,
    left: -8,
    minWidth: 56,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 2,
    borderTopRightRadius: Spacing.SCALE_20,
    borderBottomRightRadius: Spacing.SCALE_20,
    borderRightWidth: 0,
    paddingHorizontal: Spacing.SCALE_5,
    paddingVertical: Spacing.SCALE_3,
    border: "1px solid red",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    borderLeftWidth: 0,
    paddingInlineStart: "6px",
}

export const breakTaskCounter = {
    position: "absolute",
    bottom: "1px",
    left: "45px",
    justifyContent: "flex-end",
    alignItems: "center",
    borderWidth: "1px 1px 1px 1px",
    borderRadius: "20px",
    borderStyle: "solid",
    borderColor: "red",
    borderImage: "initial",
    display: "flex",
    flexDirection: "row",
    padding: "0px 3px",
}

